import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto} from "../../../api/model/rest";
import LeadUserMentionNotificationData from "./LeadUserMentionNotificationData";

/**
 * User mention notification class.
 */
export default class UserMentionNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if sms is marked as read.
	 * @param {string} type in this case always 'USER_MENTIONED'.
	 * @param {LeadUserMentionNotificationData} data user mention notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: LeadUserMentionNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): UserMentionNotification {
		return new UserMentionNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			LeadUserMentionNotificationData.fromJson(json.data as LeadUserMentionNotificationData));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new UserMentionNotification(id, dateTime, read, type, data);
	}
}